/**
 * Redux Store Configuration
 * Central store setup with Redux Toolkit
 */

import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import config from '../config/environment.config';

// Import reducers
import authReducer from './slices/auth.slice';
import clinicReducer from './slices/clinic.slice';
import patientsReducer from './slices/patients.slice';
import agencyReducer from './slices/agency.slice';

/**
 * Persist Configuration
 */
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'agency'], // Persist auth and agency slices
  version: 1,
};

/**
 * Root Reducer
 */
const rootReducer = combineReducers({
  auth: authReducer,
  clinic: clinicReducer,
  patients: patientsReducer,
  agency: agencyReducer,
});

/**
 * Persisted Reducer
 */
const persistedReducer = persistReducer(persistConfig, rootReducer);

/**
 * Configure Store
 */
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: config.enableDevtools,
});

/**
 * Persistor
 */
export const persistor = persistStore(store);

/**
 * TypeScript Types
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

